import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { Global } from '../../../shared/global';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
//import {
//  Lists_dmcanbo
//} from '../../../routes/menu'
import 'jquery'
import 'bootstrap'
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';


const swal = require('sweetalert');
@Component({
    selector: 'app-quantri-donvibanleedit',
  templateUrl: './donvibanleedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
  styleUrls: ['./donvibanleedit.component.scss'],
    providers: [ListService, Repository]
})


export class donvibanleeditComponent implements OnInit {

  @ViewChild('modaldanhsachcapsogiayphep', { static: false }) modaldanhsachcapsogiayphep: ModalComponent;
  @ViewChild('dtedanhsachcapsogiayphep', { static: false }) dtedanhsachcapsogiayphep: any;
  @ViewChild('modaldanhsachnhanvien', { static: false }) modaldanhsachnhanvien: ModalComponent;
  @ViewChild('dtedanhsachnhanvien', { static: false }) dtedanhsachnhanvien: any;
  @ViewChild('modalchondonvicaptren', { static: false }) modalchondonvicaptren: ModalComponent;
  @ViewChild('dtechondonvicaptren', { static: false }) dtechondonvicaptren: any;
  @ViewChild('modalchondonvi', { static: false }) modalchondonvi: ModalComponent;
  @ViewChild('dtechondonvi', { static: false }) dtechondonvi: any;
    @ViewChild('mdDoiTuongChung', { static: false }) mdDoiTuongChung: ModalComponent;
    @ViewChild('dteChung', { static: false }) doituongchungedit: any;
    @ViewChild('slTaiKhoanNH', { static: false }) slTaiKhoanNH: any;
    @ViewChild('inputTenKB', { static: false }) inputTenKB: any;
    inputcapdonvis: any;
    inputvungmiens: any = [
      { Id: 0, Ten: "Miền Bắc" },
      { Id: 1, Ten: "Miền Trung" },
      { Id: 2, Ten: "Miền Nam" }
    ];
  inputnoicaps: any;
  inputtinhs: any;
  inputxaphuongs: any;
  inputloais: any;

    quyen_them: boolean = false;
    quyen_sua: boolean = false;
    quyen_xoa: boolean = false;
    public ngxCurrencyOptions = {
    prefix: '',
    thousands: '.',
    decimal: ',',
    precision: 0,
    allowNegative: false
  };

    inputparents: any;
    inputnganhangs: any;
  currentUser: any;

  
    donviid: any;
    tabselected: number = 1;

    indLoading: boolean = false;    
    doituongSelect: any = {
    Id: null, Ma: null, Ten: null, DiaChi: null, DienThoai: null, Email: null,MaAo:null,
      CapTrenId: null, SapXep: null
      , Created: null, CreatedBy: null, Modified: null, ModifiedBy: null
      //, Ky_ThuTruongDonVi: null, Ky_KeToanTruong: null, Ky_ThuQuy: null, Ky_ThuKho: null, Ky_NguoiLapBaoCao: null
      , ThuocDonViId: null, TrangThai: null, VungMien: null
      , SoGiayPhep: null, NgayCap: null, NgayHetHan: null
      , NoiCapId: null, LoaiHinh: null, Tinh: null, Xa: null, DiaChiChiTiet: null
      , KinhDo: null, ViDo: null
      , CapTrenText: null, TenTiengNuocNgoai: null
    };    
    nhomdtid:string=null;


    @Output() save: EventEmitter<any> = new EventEmitter();
  
   

    constructor( private _dataService: ListService, private repo: Repository) {
       
        
    }

    ngOnInit(): void {
      

    }
  comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
  }
  comboSearchFn_DV(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ma.toLowerCase().indexOf(term) > -1 || item.Ten.toLowerCase().indexOf(term) > -1;
  }
  comboSearchFn_DV2(term: string, item: any) {
    term = term.toLowerCase();
    return  item.Ten.toLowerCase().indexOf(term) > -1;
  }

  public changeTinh($event: any) {
    if (typeof $event === "undefined") {
      this.doituongSelect.Tinh = null;
      this.doituongSelect.Xa = null;
    }
    else {
      this.doituongSelect.Tinh = $event.Id;
      this.doituongSelect.Xa = null;
      this.repo.postRequest('api/donvibanle/getxaphuong', { UserName: this.currentUser.user_name, TinhId: this.doituongSelect.Tinh })
        .subscribe(response => {
          this.inputxaphuongs = response;
        });
    }
  }

  onDoiTuongChange($event) {

    if (typeof $event === "undefined") {
      this.doituongSelect.KBNN_Ten = null;
    }
    else
      this.doituongSelect.KBNN_Ten = $event.Ten_Doi_Tuong;
  }
    @ViewChild("mafocus",{static:false}) mafocus : ElementRef;

    loadDataInit(nhomdoituongid:string, id:string, donviid: string){

      var authlogin = localStorage.getItem('currentUser');
      if (authlogin) {

        this.currentUser = JSON.parse(authlogin);
        this.donviid = this.currentUser.id_don_vi;
        var giatri = this.currentUser.ds_quyen.filter(name => name.Id === nhomdoituongid.toLowerCase());
        if (giatri != null && giatri.length > 0) {
          if (giatri[0].Them == true)
            this.quyen_them = true;
          else
            this.quyen_them = false;
          if (giatri[0].Sua == true)
            this.quyen_sua = true;
          else
            this.quyen_sua = false;
          if (giatri[0].Xoa == true)
            this.quyen_xoa = true;
          else
            this.quyen_xoa = false;
        }
      }    

        this.nhomdtid = nhomdoituongid;
        setTimeout(() => {
            this.mafocus.nativeElement.focus();  
      }, 500);
      
      this.repo.postRequest("api/donvibanle/getnoicap/", { Id: id, UserName: this.currentUser.user_name })
        .subscribe(response => {
          this.inputnoicaps = response;
        });
      this.repo.postRequest("api/donvibanle/gettinh/", { Id: id, UserName: this.currentUser.user_name })
        .subscribe(response => {
          this.inputtinhs = response;
        });
      this.repo.postRequest("api/kybaocao/getloaihinhdoanhnghiep2/", { UserName: this.currentUser.user_name })
        .subscribe(response => {
          this.inputloais = response;
        });

     

      this.doituongSelect = {
        Id: null, Ma: null, Ten: null, DiaChi: null, DienThoai: null, Email: null, MaAo: null,
        CapTrenId: null,  SapXep: null
        , Created: null, CreatedBy: null, Modified: null, ModifiedBy: null
        //, Ky_ThuTruongDonVi: null, Ky_KeToanTruong: null, Ky_ThuQuy: null, Ky_ThuKho: null, Ky_NguoiLapBaoCao: null
        , ThuocDonViId: null, TrangThai: true, VungMien: null
        , SoGiayPhep: null, NgayCap: null, NgayHetHan: null
        , NoiCapId: null, LoaiHinh: null, Tinh: null, Xa: null, DiaChiChiTiet: null
        , KinhDo: null, ViDo: null
        ,CapTrenText: null
      };    
        
        if(id === null)
        {
          this.doituongSelect.Created = new Date();
          this.doituongSelect.CreatedBy = this.currentUser.user_name;
          this.doituongSelect.Modified = new Date();
          this.doituongSelect.ModifiedBy = this.currentUser.user_name;
          //this.repo.postRequest("api/donvi/getall_pp/", { Id: null, UserName: this.currentUser.user_name })
          //  .subscribe(response => {
          //    this.inputparents = response;
          //  });
        }
        else {
          //this.repo.postRequest("api/donvi/getall_pp/", { Id: id, UserName: this.currentUser.user_name })
          //  .subscribe(response => {
          //    this.inputparents = response;
          //  });

            console.log(id);
            this.repo.getRequest("api/donvibanle/getbyid/" + id)
            .subscribe(response => {  
              console.log(response);
              this.doituongSelect.Id = id;
              this.doituongSelect.Ma = response.Ma;
              this.doituongSelect.Ten = response.Ten;
              this.doituongSelect.DiaChi = response.DiaChi;
              this.doituongSelect.DienThoai = response.DienThoai;
              this.doituongSelect.Email = response.Email;
              this.doituongSelect.MaAo = response.MaAo;
              this.doituongSelect.CapTrenId = response.CapTrenId;
              
              //this.doituongSelect.Ky_ThuTruongDonVi = response.Ky_ThuTruongDonVi;
              //this.doituongSelect.Ky_KeToanTruong = response.Ky_KeToanTruong;
              //this.doituongSelect.Ky_ThuQuy = response.Ky_ThuQuy;
              //this.doituongSelect.Ky_ThuKho = response.Ky_ThuKho;
              //this.doituongSelect.Ky_NguoiLapBaoCao = response.Ky_NguoiLapBaoCao;

              this.doituongSelect.ThuocDonViId = response.ThuocDonViId;
              this.doituongSelect.TrangThai = response.TrangThai;
              this.doituongSelect.VungMien = response.VungMien;
              this.doituongSelect.SoGiayPhep = response.SoGiayPhep;
              if (response.NgayCap != null)
                this.doituongSelect.NgayCap = new Date(response.NgayCap);
              if (response.NgayHetHan != null)
                this.doituongSelect.NgayHetHan = new Date(response.NgayHetHan);

              this.doituongSelect.SoGiayPhep = response.SoGiayPhep;
              this.doituongSelect.NoiCapId = response.NoiCapId;
              this.doituongSelect.LoaiHinh = response.LoaiHinh;
              this.doituongSelect.Tinh = response.Tinh;
              this.doituongSelect.Xa = response.Xa;
              this.doituongSelect.DiaChiChiTiet = response.DiaChiChiTiet;
              this.doituongSelect.KinhDo = response.KinhDo;
              this.doituongSelect.ViDo = response.ViDo;
              if (this.doituongSelect.Tinh != null) {
                this.repo.postRequest('api/donvibanle/getxaphuong', { UserName: this.currentUser.user_name, TinhId: this.doituongSelect.Tinh })
                  .subscribe(response => {
                    this.inputxaphuongs = response;
                  });
              }
            
              this.doituongSelect.SapXep = response.SapXep;
              this.doituongSelect.Created = response.Created;
              this.doituongSelect.CreatedBy = response.CreatedBy;
              this.doituongSelect.Modified = new Date();
              this.doituongSelect.ModifiedBy = this.currentUser.user_name;
              this.doituongSelect.CapTrenText = response.CapTrenText;

              this.repo.postRequest("api/giayphep/getthongtindonviid/", {DonViId: this.doituongSelect.CapTrenId })
                .subscribe(response => {
                  if (response != null) {
                    this.doituongSelect.TenTiengNuocNgoai = response.TenTiengNuocNgoai;
                  }
                });

              this.Loaddatas();

            }); 
        }
        
       
    }
  selectedTab(tab: number) {
    this.tabselected = tab;
    if (tab === 2) {

    }
    else {
      setTimeout(() => {
        this.mafocus.nativeElement.focus();
      }, 100);
    }
   
  }
    keyTenPress(event: any) { 
        if (event.which === 13) {
          // this.slLoaiTaiSan.focus();
            event.preventDefault();
          }
  }
  keySoTKPress(event: any) {
    if (event.which === 13) {
       this.inputTenKB.focus();
      event.preventDefault();
    }
  }
  
  adddata_tknh() {
    this.dtedanhsachcapsogiayphep.loadDataInit(null, null, "03", this.doituongSelect.CapDonViId, this.doituongSelect.Id, this.doituongSelect.NoiCapId);
    this.mBackdrop = setTimeout(() => {
      this.haveBackdrop();
    }, 500);
    this.modaldanhsachcapsogiayphep.open();
  }
  saveModal_02(doituong: any) {
    this.modaldanhsachcapsogiayphep.dismiss();

  }

  adddata_nhanvien() {
    if (!this.dtedanhsachnhanvien || !this.modaldanhsachnhanvien) {
      return;
    }
    if (!this.doituongSelect || !this.doituongSelect.Id) {
      return;
    }
    this.modaldanhsachnhanvien.open();
    setTimeout(() => {
      this.dtedanhsachnhanvien.loadDataInit(this.doituongSelect.Id, this.doituongSelect.Ten);
    }, 100);
  }
  saveModal_nhanvien(_doituong: any) {
    this.modaldanhsachnhanvien.dismiss();
  }

  adddatachondoituongchung(index: number) {
    let donvi = '234,235,236,256,257';
    this.dtechondonvicaptren.loadDataInit(null, null, "03", donvi, this.doituongSelect.Id, 1);
    this.modalchondonvicaptren.open();
  }
  savedsdoituongchung(doituong: any) {
    let i = 0;
    if (doituong != null) {
      doituong.forEach(
        (item) => {
          if (i == 0) {
            this.repo.postRequest("api/giayphep/getthongtindonviid/", { DonViId: item.Id })
              .subscribe(response => {
                if (response != null) {
                  this.doituongSelect.CapTrenId = item.Id;
                  this.doituongSelect.TenTiengNuocNgoai = response.TenTiengNuocNgoai;
                }
                this.modalchondonvicaptren.close();
              });
          }

        }
      );
    }
    else {
      this.doituongSelect.DonViId = null;
      this.doituongSelect.DonVi = null;
      this.modalchondonvicaptren.close();
    }
  }


  mBackdrop: any;
  haveBackdrop() {
    if ($('.modal-backdrop').length > 0) {
      $('.modal-backdrop').css("z-index", -1)
      clearTimeout(this.mBackdrop);
      return true;
    }

    return false;
  }

  datas: any;
  public totalItems: number = 0;
  public currentPage: number = 1;
  public StartPage: number = 1;
  public EndPage: number = 20;
  public pageSize: number = 20;
  public pages: any;
  public totalPages: number;
  public TimKiem1s: any = {
    Don_Vi_Id: null
    , UserName: null
    , startPage: null
    , endPage: null
    , Ma: null
    , Ten: null
    , DiaChi: null
    , ModifiedS: null
    , ModifiedBy: null
    , SapXep: null
  };
  onKeydownEvent1(event: KeyboardEvent): void {
    if (event.keyCode === 13) {
      this.currentPage = 1;
      this.Loaddatas();
    }
  }
  setPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }
    this.currentPage = page;
    this.Loaddatas();
  }
  Loaddatas(): void {
    if (this.doituongSelect == null || this.doituongSelect.Id == null)
      return;
    this.datas = [];
    this.StartPage = (this.currentPage - 1) * this.pageSize + 1;
    this.EndPage = this.currentPage * this.pageSize;
    this.totalItems = 0;
    this.TimKiem1s.Don_Vi_Id = this.doituongSelect.Id;
    this.TimKiem1s.UserName = this.currentUser.user_name;
    this.TimKiem1s.startPage = this.StartPage;
    this.TimKiem1s.endPage = this.EndPage;
    this.repo.postRequest("api/donvi/get_nhacungcap_listviewpage/", this.TimKiem1s)
      .subscribe(response => {
        this.totalPages = 0;
        this.totalItems = 0;
        if (response != null && response.length > 0) {
          var item = response[0];
          this.totalItems = item["totalRows"];
          this.totalPages = Math.ceil(this.totalItems / this.pageSize);
          let start, end;
          if (this.totalPages <= 5) {
            start = 1;
            end = this.totalPages;
          } else {
            if (this.currentPage <= 3) {
              start = 1;
              end = 5;
            } else if (this.currentPage + 1 >= this.totalPages) {
              start = this.totalPages - 4;
              end = this.totalPages;
            } else {
              start = this.currentPage - 2;
              end = this.currentPage + 2;
            }
          }
          let resultArray: Array<any> = [];
          for (var i = start; i <= end; i++) {
            resultArray.push({ Id: i, Ten: null });
          }
          this.pages = resultArray;
        }
        this.datas = response;
      });
  }
  adddata_01() {
    let donvi = "235,236";
    this.dtechondonvi.loadDataInit(null, null, "03", donvi, this.doituongSelect.Id, 2);
    this.mBackdrop = setTimeout(() => {
      this.haveBackdrop();
    }, 500);
    this.modalchondonvi.open();
  }
  saveModal_01(doituong: any) {
    this.modalchondonvi.dismiss();
    this.Loaddatas();
  }
  deletedata_01(id: string) {
    swal({
      title: 'Bạn muốn xóa bản ghi?',
      text: 'Dữ liệu xóa sẽ không phục hồi lại được!',
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          this.repo.getRequest('api/donvi/delete_nhacungcap/' + id).subscribe(
            data => {
              if (data == "OK") {
                swal('Deleted!', 'Dữ liệu đã được xóa!.', 'success');
                this.Loaddatas();
              }
              else {
                alert(data);
              }
            }
          );
        }
      });
  }
  
    public closeModal(){
        this.save.emit(null);
    }
  public saveproduct() {
    if (this.doituongSelect.Ma == null || this.doituongSelect.Ma == "") {
      swal('Lỗi!', 'Vui lòng nhập mã số thuế!.', 'error');
      return;
    }
    if (this.doituongSelect.Ten == null || this.doituongSelect.Ten == "") {
            swal('Lỗi!', 'Vui lòng nhập tên đơn vị bán lẻ!.', 'error');
            return;
      }

    if (this.doituongSelect.Tinh == null) {
      swal('Lỗi!', 'Vui lòng nhập thông tin tỉnh!.', 'error');
      return;
    }
      
      
      this.repo.postRequest("api/donvibanle/addorupdate",this.doituongSelect)
        .subscribe(response => {
                    //if (response != null && response.match('-')) {
          if (response == 0 || (response != null && parseInt(response))) {
                      this.doituongSelect.Id = response;
                      this.save.emit(this.doituongSelect);
                    }
                    else {
                      swal('Lỗi!', response, 'error');
                    }
               
            }); 
    }
   
  comboSeleted: NgSelectComponent;
  AddDoiTuong(cobo: NgSelectComponent) {

    //this.comboSeleted = cobo;
    //cobo.close();
    //this.doituongchungedit.loadDataInit(Lists_dmcanbo.id, null, this.donviid);
    //this.mdDoiTuongChung.open();
  }
  saveModal(doituong: any) {
    console.log(doituong);
    this.mdDoiTuongChung.dismiss();
    this.comboSeleted.focus();
  }
   


}


